//export const BASE_URL = 'http://localhost:8087/quadrum-consulta-recibos-nomina-clientes-backend/';
export const BASE_URL = 'https://q-nomina.com.mx/quadrum-consulta-recibos-nomina-clientes-backend/';